export default {
    AVAILABLE_CHART_COLORS:
    {
        BAR: ['#ff6384', '#4bc0c0', '#ffce56', '#36a2eb', '#c14b7a', '#53b59f', '#c7d68f', '#662d91', '#8094c4', '#e7e9ed'],
        LINE: ['#ff6384', '#4bc0c0', '#ffce56', '#36a2eb', '#c14b7a', '#53b59f', '#c7d68f', '#662d91', '#8094c4', '#e7e9ed'],
        RADIAL: ['#ff6384', '#4bc0c0', '#ffce56', '#e7e9ed', '#36a2eb', '#c14b7a', '#53b59f', '#c7d68f', '#662d91', '#8094c4'],
    },
    AVAILABLE_CHART_COLORS_BY_DATA_TYPE: {
        ATTEMPT_CALL: '#008040',
        ATTEMPT_FOLLOW_UP_MAIL: '#02203E',
        ATTEMPT_MAIL: '#0080d5',
        ATTEMPT_SMS: '#F2930F',

        BOOKINGS: '#0080d5',
        BOOKINGS_INVERSE: '#c9ccc8',
        CANCELLED_BOOKINGS: '#e53e3d',

        SALES_GROSS: '#004c7f',
        SALES_PROFIT: '#008040',
        SALES_PROFIT_INVERSE: '#004c7f',

        INCOME_GROSS: '#004c7f',
        INCOME_DUE: '#e53e3d',
        INCOME_PENDING: '#e37c22',
        INCOME_PROFIT: '#008040',
        INCOME_PROFIT_INVERSE: '#004c7f',
        INCOME_B2B_PROFIT: '#004c7f',
        INCOME_B2C_PROFIT: '#008040',
    },
    AVAILABLE_COLORS: [
        'black',
        'primary-lightest',
        'primary-lighter',
        'primary',
        'primary-darker',
        'primary-darkest',
        'info-lightest',
        'info-lighter',
        'info',
        'info-darker',
        'info-darkest',
        'danger-lightest',
        'danger-lighter',
        'danger',
        'danger-darker',
        'danger-darkest',
        'warning-lightest',
        'warning-lighter',
        'warning',
        'warning-darker',
        'warning-darkest',
        'white',
        'purple-lightest',
        'purple-lighter',
        'purple',
        'purple-darker',
        'purple-darkest',
        'teal-lightest',
        'teal-lighter',
        'teal',
        'teal-darker',
        'teal-darkest',
    ],
    AVAILABLE_SIZES: ['xs', 'sm', 'md', 'lg'],
};
